export default {
      id: "fill-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#fill-usage",
      toString: function () {
        return this.url;
      }
    }